export const QUERY_KEYS = {
  USERS: {
    FRIENDS_BONUSES: "friendsBonuses",
    GET_REFERRALS: "GET_REFERRALS",
    LOGIN: "login",
    ME: "me",
    CLIENT: "CLIENT",
    REFERRAL_PAYMENTS: { ALL: "REFERRAL_PAYMENTS_ALL" },
  },
  EXCHANGE: {
    ALL: "ALL_EXCHANGE",
    LIST_SBP: "LIST_SBP",
    ONE_EXCHANGE: "ONE_EXCHANGE",
    RATE: "RATE",
    RECENT_WALLETS: "RECENT_WALLETS",
  },
  WITHDRAWAL: {
    ALL: "ALL_WITHDRAWAL",
  },
};
